import { useMemo, useState } from 'react';

export function TransparencyPortal() {
  const [q, setQ] = useState('');
  const certs = [{ id:'MUNI-001', tons: 120, issued:'2025-10-01' }, { id:'MUNI-002', tons: 95, issued:'2025-10-10' }];
  const filtered = useMemo(()=> certs.filter(c=> c.id.toLowerCase().includes(q.toLowerCase())), [q]);
  return (
    <div className="space-y-3">
      <div className="font-orbitron text-evat-gold">Transparency Portal (Public)</div>
      <input value={q} onChange={(e)=>setQ(e.target.value)} placeholder="Search certificate ID" className="w-full bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 text-sm"/>
      <div className="border border-neutral-700 rounded p-2 text-sm max-h-56 overflow-auto">
        {filtered.map(c => <div key={c.id} className="flex justify-between"><span>{c.id}</span><span>{c.tons} t</span><span>{c.issued}</span></div>)}
        {filtered.length===0 && <div className="text-neutral-500">No matches</div>}
      </div>
      <div className="text-xs text-neutral-500">Search (demo): paste certificate ID into your auditor tool to validate hash</div>
    </div>
  );
}

export default TransparencyPortal;


